export default "__VITE_ASSET__9120d37e__"